import React from 'react';

/**
 * SVG Marker Definitions для ArchiMate связей
 * Добавьте этот компонент в SVG canvas внутри <defs>
 */
export const ArchiMateArrowMarkers = () => (
  <>
    {/* Стандартная стрелка */}
    <marker
      id="archimate-arrow"
      markerWidth="10"
      markerHeight="10"
      refX="9"
      refY="3"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,0 L0,6 L9,3 z" fill="currentColor" />
    </marker>

    {/* Заполненная стрелка (для Triggering, Flow) */}
    <marker
      id="archimate-filled-arrow"
      markerWidth="10"
      markerHeight="10"
      refX="9"
      refY="3"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,0 L0,6 L9,3 z" fill="currentColor" />
    </marker>

    {/* Треугольник (для Realization, Specialization) */}
    <marker
      id="archimate-triangle"
      markerWidth="12"
      markerHeight="12"
      refX="11"
      refY="4"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,0 L0,8 L11,4 z" fill="white" stroke="currentColor" strokeWidth="1" />
    </marker>

    {/* Ромб пустой (для Aggregation) */}
    <marker
      id="archimate-diamond"
      markerWidth="14"
      markerHeight="10"
      refX="13"
      refY="5"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,5 L5,0 L13,5 L5,10 z" fill="white" stroke="currentColor" strokeWidth="1" />
    </marker>

    {/* Ромб заполненный (для Composition) */}
    <marker
      id="archimate-filled-diamond"
      markerWidth="14"
      markerHeight="10"
      refX="13"
      refY="5"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,5 L5,0 L13,5 L5,10 z" fill="currentColor" />
    </marker>

    {/* Круг заполненный (для Assignment start) */}
    <marker
      id="archimate-filled-circle"
      markerWidth="10"
      markerHeight="10"
      refX="5"
      refY="5"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <circle cx="5" cy="5" r="4" fill="currentColor" />
    </marker>
  </>
);

/**
 * Получить URL маркера для типа наконечника
 */
export const getArchimateMarkerUrl = (capType) => {
  switch (capType) {
    case 'arrow':
      return 'url(#archimate-arrow)';
    case 'filled_arrow':
      return 'url(#archimate-filled-arrow)';
    case 'triangle':
      return 'url(#archimate-triangle)';
    case 'diamond':
      return 'url(#archimate-diamond)';
    case 'filled_diamond':
      return 'url(#archimate-filled-diamond)';
    case 'filled_circle':
      return 'url(#archimate-filled-circle)';
    case 'none':
    default:
      return null;
  }
};

export default ArchiMateArrowMarkers;
